module.exports = __webpack_public_path__ + "assets/c3881a550406c74b62a1c4c642df38c3.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/win/Level3_Hit10s.mp3
 ** module id = 336
 ** module chunks = 0
 **/